import { getDisplayedFigures, getLegendItemForGrade } from "@l2r-front/l2r-common"
import { useTheme } from "@l2r-front/l2r-ui"

import { notationLegend } from "../../constants/getNotationConfig"

import * as Styled from "./YearGradingBadge.styled"

export function YearGradingBadge(props: YearGradingBadgeProps) {

    const {
        className,
        id,
        figuresCount = 2,
        grade,
        year,
    } = props

    const theme = useTheme()

    const gradeIsNull = !grade && grade !== 0
    const legendItemForGrade = getLegendItemForGrade(notationLegend, grade, theme)
    const backgroundColor = gradeIsNull
        ? theme.palette["action/disabled"].main
        : theme.palette[legendItemForGrade.color]?.main
    const textColor = gradeIsNull ? "black" : legendItemForGrade.textColor
    const displayedGrade = gradeIsNull ? "-" : getDisplayedFigures(grade, figuresCount)

    return <Styled.Wrapper
        backgroundColor={backgroundColor}
        className={className}
        id={id}
    >
        <Styled.Text
            color={textColor}
            variant="Desktop & Mobile/Body/Small"
        >
            {year}
        </Styled.Text>
        <Styled.Text
            color={textColor}
            variant="Desktop & Mobile/Heading/H4"
        >
            {displayedGrade}
        </Styled.Text>
    </Styled.Wrapper>
}

type YearGradingBadgeProps = {
    className?: string
    id?: string
    figuresCount?: number
    grade?: number
    year: number
}